var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgRedditBlack = function SvgRedditBlack(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12.782,
    height: 14.748,
    viewBox: "0 0 12.782 14.748",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "reddit-black-icon",
    transform: "translate(-28.547 -24.016)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M132.391,106l3.2,1.819,3.2,1.868v7.374l-3.2,1.868-3.2,1.819-3.2-1.819-3.2-1.868v-7.374l3.2-1.868Z",
    transform: "translate(-97.453 -81.984)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M132.391,120.748l-3.2-1.819-3.2-1.868v-7.374l3.2-1.868,3.2-1.819Z",
    transform: "translate(-97.453 -81.984)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M153.309,131l2.655,1.524,2.655,1.524v6.194l-2.655,1.524-2.655,1.524-2.655-1.524L148,140.242v-6.194l2.655-1.524Z",
    transform: "translate(-118.372 -105.755)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M192.284,199.663a3.88,3.88,0,0,0-1.524.393,1.993,1.993,0,0,0-.442.246,1.075,1.075,0,0,0-.246-.147.72.72,0,0,0-.737,1.229c.049.049.1.049.1.1a1.742,1.742,0,0,0,.2,1.131,3.121,3.121,0,0,0,2.7,1.327,3.334,3.334,0,0,0,2.065-.639,2.142,2.142,0,0,0,.639-.688,1.737,1.737,0,0,0,.2-.836v-.295a.77.77,0,0,0-.246-1.426,1.389,1.389,0,0,0-.639.2c-.049,0-.1-.049-.147-.1-.049,0-.1-.049-.2-.1a3.39,3.39,0,0,0-.393-.147,5.222,5.222,0,0,0-.934-.2,9.173,9.173,0,0,1,.344-1.082l.934.2c.1.1.1.442.541.492a.539.539,0,1,0-.1-1.032c-.2.049-.2.1-.295.2a10.169,10.169,0,0,1-1.082-.2c-.295-.1-.295.049-.393.393C192.579,198.828,192.334,199.614,192.284,199.663Zm-.983,2.851c-.1,0-.2.1-.1.246a1.072,1.072,0,0,0,.246.2,2.02,2.02,0,0,0,1.917-.1c.295-.2.049-.442-.147-.344a1.609,1.609,0,0,1-1.327.246C191.547,202.613,191.449,202.465,191.3,202.515Zm1.966-1.524a.42.42,0,0,0-.344.541.43.43,0,0,0,.541.344.453.453,0,0,0-.2-.885Zm-2.016,0a.461.461,0,0,0-.393.541.5.5,0,0,0,.541.344.43.43,0,0,0,.344-.541A.413.413,0,0,0,191.252,200.991Z",
    transform: "translate(-157.396 -169.699)",
    fill: "#fff",
    fillRule: "evenodd"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRedditBlack, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/reddit-black.9f567c2b.svg";
export { ForwardRef as ReactComponent };